import { Stack, Typography } from '@mui/material';
import { LightTooltip } from 'components/ui-new/light-tooltip/light-tooltip';
import { InfoIcon } from 'icons/info';
import s from '../manage-failed-tasks-modal.module.scss';

const FinishedAdditionalTasksHeader = () => (
  <div className={s.newly_added_additional_task_header}>
    <div>Finished additional tasks</div>
    <Stack display="flex" flexDirection="row" gap="27px">
      <Typography fontWeight={500}>Fail</Typography>

      <Stack direction="row" alignItems="center" gap="4px">
        <Typography fontWeight={500}>UAH</Typography>
        <LightTooltip className={s.tooltip} placement="bottom-start" title="A new task will be created to complete this job">
          <Stack direction="row" alignItems="center">
            <InfoIcon height={16} width={16} />
          </Stack>
        </LightTooltip>
      </Stack>
    </Stack>
  </div>
);

export default FinishedAdditionalTasksHeader;
